const timeDOM = document.getElementById('waiting-room-timer-show');

let ticker = 60;

let poller = setInterval(() => {
  ticker -= 1;

  timeDOM.innerText = ticker.toString();

  if (ticker == 0) {
    clearInterval(poller);
    location.reload();
  }
}, 1_000);